import template from './racedayEditForm.html';
import controller from './racedayEditForm.controller';
import './racedayEditForm.scss';

let racedayEditFormComponent = {
  restrict: 'E',
  bindings: {
    save: '&',
    validation: '<',
    raceday: '=',
    storeFile: '&',
    removeFile: '&'
  },
  template,
  controller
};

export default racedayEditFormComponent;
